export default __webpack_public_path__ + "static/media/obj2.53cf4e54.svg";